import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import emailService from "../../../services/sendEmail";
import auth from "../../../services/security/auth.service";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';

const Reset = () => {
    let navigate = useNavigate();
    const [error, setError] = useState('');
    const [code, setCode] = useState(false);
    const [codigo, setCodigo] = useState('');
    const [email, setEmail] = useState('');
    const [inputCode, setInputCode] = useState('');
    const [password, setPassword] = useState('');
    const [password1, setPassword1] = useState('');
    const [validaCode, setValidaCode] = useState(false);
    const [errorValidateEmail, setErrorValidateEmail] = useState(null);
    useEffect(() => {
        document.title = `wBroker`;

    })
    const defaultTheme = createTheme();

    const onChangeEmail = (event) => {
        setEmail(event.target.value)
    }

    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }

    const onValidateEmail = (e) => {
        setErrorValidateEmail('');
        if (e.target.value) {
            if (!isValidEmail(e.target.value)) {
                setErrorValidateEmail('Email es inválido');
            } else {
                setErrorValidateEmail(null);
            }
        }
    };

    const handleSetCode = () => {
        auth.validateEmail(email).then((response) => {
            console.log('Respuesta usuario-> ' + response.data)

            if (response.data) {
                setCode(true);
                let idCode = generateIdCode();
                let mail = {
                    recipient: email,
                    msgBody: `El código de seguridad es: \n ${idCode}\n\nSaludos \n\nwBroker`,
                    subject: 'Reestablecer contraseña'
                }
                setCodigo(idCode);
                setError('')
                emailService.sendEmail(mail).then((response) => {
                }).catch((error) => {
                    console.log(error);
                    setError(error)
                });
            } else {
                setError('El email del usuario no se encuentra registrado.')
            }

        }).catch((error) => {
            console.log(error);
        });


    }

    const onChangePassword = (event) => {
        setPassword(event.target.value)
    }

    const onChangePassword1 = (event) => {
        setPassword1(event.target.value)
    }

    const validateCode = () => {

        if (inputCode === codigo) {
            setError('')
            setValidaCode(true);
        } else {
            setError('El código ingresado es incorrecto, vuelva a ingresar')
        }
    }

    const onChangeInputCode = (event) => {
        setInputCode(event.target.value);
    }

    const updatePassword = () => {

        setError('');

        if (!password.trim()) {

            setError('Contraseña es obligatoria');
            return;

        }

        if (password.length < 8) {

            setError(
                'La contraseña debe tener al menos 8 caracteres'
            );
            return;

        }

        if (!/[A-Z]/.test(password)) {

            setError(
                'La contraseña debe contener al menos una mayúscula'
            );
            return;

        }

        if (!/[a-z]/.test(password)) {

            setError(
                'La contraseña debe contener al menos una minúscula'
            );
            return;

        }

        if (!/[0-9]/.test(password)) {

            setError(
                'La contraseña debe contener al menos un número'
            );
            return;

        }

        if (!/[!@#$%^&*(),.?":{}|<>_\-]/.test(password)) {

            setError(
                'La contraseña debe contener al menos un carácter especial (!,#,$,...)'
            );
            return;

        }

        if (password !== password1) {

            setError(
                'Las contraseñas deben coincidir'
            );
            return;

        }


        const request = {
            email,
            password
        };


        auth.updatePassword(request)
            .then((response) => {

                navigate("/");
                window.location.reload();

            })
            .catch((error) => {

                console.log(error);

            });
    };

    const generateIdCode = () => {
        const letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const numeros = '0123456789';
        const nuevoValor = [];

        for (let i = 0; i < 3; i++) {
            nuevoValor.push(letras[Math.floor(Math.random() * letras.length)]);
        }

        for (let i = 0; i < 3; i++) {
            nuevoValor.push(numeros[Math.floor(Math.random() * numeros.length)]);
        }

        return nuevoValor.join('');
    };


    const isValidPassword = (password) => {
        return (
            password.length >= 8 &&
            /[A-Z]/.test(password) &&
            /[a-z]/.test(password) &&
            /[0-9]/.test(password) &&
            /[!@#$%^&*(),.?":{}|<>_\-]/.test(password)
        );
    };


    return (
        <ThemeProvider theme={defaultTheme}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar sx={{ m: 1, bgcolor: 'blue' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Reestablecer contraseña
                    </Typography>

                    {!code && (
                        <div item xs={12}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="Email"
                                name="email"
                                autoComplete="email"
                                autoFocus
                                onChange={onChangeEmail}
                                onBlur={onValidateEmail}
                                value={email}
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                                onClick={handleSetCode}
                            >
                                Continuar
                            </Button>
                            {error && <h4 style={{ color: 'red' }}>{error}</h4>}
                            {errorValidateEmail && <h4 style={{ color: 'red' }}>{errorValidateEmail}</h4>}

                        </div>
                    )}

                    {code && !validaCode && (

                        <Grid item xs={12}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="inputcode"
                                label="Ingrese el código recibido por email"
                                name="código"
                                autoComplete="inputcode"
                                autoFocus
                                onChange={onChangeInputCode}
                                value={inputCode}
                            />

                            <Button type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                                onClick={validateCode}>
                                Ingresar a reestablecer Contraseña
                            </Button>
                            {error && <h4 style={{ color: 'red' }}>{error}</h4>}
                        </Grid>
                    )}

                    {validaCode && (
                        <><Grid item xs={12}>

                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="password"
                                label="Ingrese Contraseña"
                                name="password"
                                autoComplete="password"
                                autoFocus
                                onChange={onChangePassword}
                                value={password}
                                type={'password'}
                            />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="password1"
                                label="Repita la Contraseña"
                                name="password1"
                                autoComplete="password1"
                                onChange={onChangePassword1}
                                value={password1}
                                type={'password'}
                            />
                            <Button type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                                onClick={updatePassword} >
                                Actualizar Contraseña
                            </Button>
                            {error && <h4 style={{ color: 'red' }}>{error}</h4>}
                        </Grid>

                            <Box
                                sx={{
                                    border: '2px solid #bbbbbb',
                                    padding: '12px 14px',
                                    marginTop: 2,
                                    color: 'rgba(0, 0, 0, 0.5)',
                                    fontSize: '0.75rem',
                                    lineHeight: 1.4
                                }}
                            >
                                <div>
                                    La contraseña debe contener al menos:
                                </div>

                                <ul
                                    style={{
                                        marginTop: 4,
                                        marginBottom: 0,
                                        paddingLeft: 18
                                    }}
                                >
                                    <li>8 caracteres</li>
                                    <li>1 mayúsculas</li>
                                    <li>1 minúsculas</li>
                                    <li>1 número</li>
                                    <li>1 caracter especial (!,#,$,...)</li>
                                </ul>
                            </Box>
                        </>

                    )}
                </Box>
            </Container >
        </ThemeProvider >
    )
}

export default Reset

